export default __webpack_public_path__ + "static/media/GSP9.335be8be.png";